import { type RouteObject, redirect } from 'react-router-dom';
import { ThemeColorMode } from 'src/common/enums';
import type { ThmRouteObject } from 'src/common/interfaces';
import { routeProtector } from '../route-protector';
import { pt1Routes } from './pt1';
import { socSimRoutes } from './soc-sim';
const fullScreen = {
  hideFooter: true,
  forcedTheme: ThemeColorMode.DARK,
  headerDisplayNone: true
};
const fullScreenWithFooter = {
  hideHeader: true,
  forcedTheme: ThemeColorMode.DARK
};
const makeChildrenFullScreen = (route: ThmRouteObject | undefined): ThmRouteObject => {
  if (!route) return {};
  let children: ThmRouteObject[] | undefined;
  if (route.children) {
    children = route.children.map(child => makeChildrenFullScreen({
      ...child
    }));
  }
  return {
    ...route,
    children,
    handle: fullScreen
  } as ThmRouteObject;
};

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const socSimModifiedRoute = makeChildrenFullScreen(socSimRoutes[0]);
const pt1ModifiedRoute = makeChildrenFullScreen(pt1Routes[0]);
export const certificationRoutes: RouteObject[] = [{
  path: '/security-analyst-level-1',
  loader: () => redirect('/certification/security-analyst-level-1')
}, {
  path: '/certifications',
  async lazy() {
    const {
      CertificationsPage
    } = await import('src/features/certifications/certifications-page');
    return {
      Component: CertificationsPage
    };
  },
  handle: {
    forcedTheme: ThemeColorMode.DARK
  }
}, {
  path: '/certification',
  children: [{
    path: '',
    loader: () => redirect('/not-found')
  }, {
    path: 'security-analyst-level-1',
    loader: routeProtector(),
    handle: {
      forcedTheme: ThemeColorMode.DARK
    },
    async lazy() {
      const {
        SecurityAnalystLandingPage
      } = await import('src/features/certifications/SAL1/security-analyst-landing-page');
      return {
        Component: SecurityAnalystLandingPage
      };
    }
  }, {
    path: 'junior-penetration-tester',
    loader: routeProtector().requireFeatureFlag('pt1-exam'),
    handle: {
      forcedTheme: ThemeColorMode.DARK
    },
    async lazy() {
      const {
        PentesterLandingPage
      } = await import('src/features/certifications/PT1/pentester-landing-page');
      return {
        Component: PentesterLandingPage
      };
    }
  }, {
    path: 'security-analyst-level-1/details',
    loader: routeProtector().requireLogin('/certification/security-analyst-level-1'),
    async lazy() {
      const {
        JuniorSecurityAnalyst
      } = await import('src/features/certifications/SAL1/junior-security-analyst');
      return {
        Component: JuniorSecurityAnalyst
      };
    }
  }, {
    path: 'junior-penetration-tester/details',
    loader: routeProtector().requireFeatureFlag('pt1-exam').requireLogin('/certification/junior-penetration-tester'),
    async lazy() {
      const {
        PentesterLevel1
      } = await import('src/features/certifications/PT1/junior-pentester');
      return {
        Component: PentesterLevel1
      };
    }
  }, {
    path: 'exam/:certificationSlug',
    loader: routeProtector().requireLogin('/certification/security-analyst-level-1'),
    async lazy() {
      const {
        CertificationExam
      } = await import('src/features/certifications/exam');
      return {
        Component: CertificationExam
      };
    },
    handle: fullScreen,
    children: [{
      ...socSimModifiedRoute,
      path: 'soc-sim'
    }, {
      ...pt1ModifiedRoute,
      path: 'pt1'
    }]
  }, {
    path: 'exam/:certificationSlug/results',
    loader: routeProtector().requireLogin('/certification/security-analyst-level-1'),
    async lazy() {
      const {
        CertificationResults
      } = await import('src/features/certifications/exam/certification-results');
      return {
        Component: CertificationResults
      };
    },
    handle: fullScreenWithFooter
  }, {
    path: 'certificate/sal1',
    loader: routeProtector().requireLogin(),
    async lazy() {
      const {
        Sal1CertificateRedirect
      } = await import('src/features/certifications/components/certificate-redirect/sal1-certificate-redirect');
      return {
        Component: Sal1CertificateRedirect
      };
    }
  }, {
    path: 'certificate/pt1',
    loader: routeProtector().requireLogin(),
    async lazy() {
      const {
        Pt1CertificateRedirect
      } = await import('src/features/certifications/components/certificate-redirect/pt1-certificate-redirect');
      return {
        Component: Pt1CertificateRedirect
      };
    }
  }, {
    path: 'certificate/:certificationSlug',
    handle: {
      forcedTheme: ThemeColorMode.DARK
    },
    async lazy() {
      const {
        CertificatePage
      } = await import('src/features/certifications/certification');
      return {
        Component: CertificatePage
      };
    }
  }]
}];